export default __webpack_public_path__ + "3c2f68020432500765fec306b88330dc.svg";